import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import './style.scss'

export default class TooltipContent extends Component {
    static propTypes = {
        endDate: PropTypes.string,
        name: PropTypes.string,
        startDate: PropTypes.string,
        translates: PropTypes.shape({
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    render() {
        const {
            startDate,
            endDate,
            name,
            translates: { to, from },
        } = this.props

        return (
            <div className={'roles-tooltip-content'}>
                <div>{name}</div>
                {startDate && (
                    <div>
                        {from} {moment(startDate).format('DD. MM. YYYY')}
                    </div>
                )}
                {endDate && (
                    <div>
                        {to} {moment(endDate).format('DD. MM. YYYY')}
                    </div>
                )}
            </div>
        )
    }
}
